export default __webpack_public_path__ + "static/business-back-1b7281cdf8232cb402d569088285de3c.webp";